let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("vgynd")).then(() => parcelRequire('G1EII'));